import { Route, Router, Switch } from 'wouter'
import { BasedClient } from '@based/sdk/client'
import { Provider as BasedClientProvider } from '@based/sdk/react'
import { Landing } from './pages/Landing'
import { SsrContextType } from '@app/util/contexts/SsrContext'
import { TENANT_URL } from './based.config'
import steunpuntAmsterdamConfig from './tenantConfig'
import { BlogItemPage } from '@app/pages/blog/BlogItem'
import { StoriesPage } from './pages/StoriesPage'
import { AgendaPage } from '@app/pages/agenda/AgendaPage'
import { pages } from '@app/util/links'
import { TenantContextProvider } from '@app/util/contexts/TenantContextProvider'
import { ScrollToTop } from '@app/components/core/scrollToTop/ScrollToTop'
import { ToastProvider } from '@app/util/contexts/ToastProvider'
import { KnowledgeHub } from '@app/pages/knowledge-hub'
import { KnowledgeHubModulePage } from '@app/pages/knowledge-hub/KnowledgeHubModule'
import { EventPage } from '@app/pages/events/EventItem'

const TENANT_BASE = `/${TENANT_URL}`

const resolveBase = (ssrPath?: string): string => {
  const path =
    ssrPath ?? (typeof window !== 'undefined' ? window.location.pathname : '/')
  return path.startsWith(TENANT_BASE) ? TENANT_BASE : ''
}

const App = ({
  ssrPath,
  basedClient,
}: {
  ssrPath?: string
  basedClient: BasedClient
  ssrContext?: SsrContextType
}) => {
  const base = resolveBase(ssrPath)

  return (
    <Router ssrPath={ssrPath} base={base}>
      <BasedClientProvider client={basedClient}>
        <ToastProvider>
          <TenantContextProvider {...steunpuntAmsterdamConfig}>
            <ScrollToTop />
            <Switch>
              <Route path={'/'} component={Landing} />

              {/* Stories */}
              <Route path={pages.blogs()} component={StoriesPage} />
              <Route path={pages.blog(':blogType', ':blogId')}>
                {(params: { blogId: string }) => (
                  <BlogItemPage blogId={params.blogId} />
                )}
              </Route>

              <Route path={pages.events} component={AgendaPage} />
              <Route path={pages.event(':slug')}>
                {(params: { slug: string }) => (
                  <EventPage eventSlug={params.slug} />
                )}
              </Route>

              {/* Knowledge Hub */}
              <Route path={pages.knowledgeHub} component={KnowledgeHub} />
              <Route path={pages.knowledgeHubModule(':key')}>
                {(params: { key: string }) => (
                  <KnowledgeHubModulePage itemId={params.key} />
                )}
              </Route>
            </Switch>
          </TenantContextProvider>
        </ToastProvider>
      </BasedClientProvider>
    </Router>
  )
}

export default App
